import { useEffect, useState } from "react";
import "./totalScoreBar.css"; // Import the CSS file
import Image from "next/image";
import { useAppSelector } from "lib/redux/hooks";
import { selectScoreAnalysis } from "lib/redux/scoreAnalysisSlice";

export const TotalScoreBar = ({
  totalScore,
  maxTotalScore = 100,
}: {
  totalScore: number;
  maxTotalScore?: number;
}) => {
  const widthPercent = (totalScore / maxTotalScore) * 100;
  const [percent, setPercent] = useState(0);
  const [isAnimating, setIsAnimating] = useState(false);
  const analysisScore = useAppSelector(selectScoreAnalysis)
  useEffect(() => {
    setPercent(0);

    const startDelay = setTimeout(() => {
      setIsAnimating(true);

      const animationDuration = 1500;
      const startTime = performance.now();

      const animateScore = (currentTime: number) => {
        const elapsedTime = currentTime - startTime;
        const progress = Math.min(elapsedTime / animationDuration, 1);
        const easeProgress = 1 - (1 - progress) * (1 - progress);

        const currentPercent = easeProgress * widthPercent;
        setPercent(currentPercent);

        if (progress < 1) {
          requestAnimationFrame(animateScore);
        } else {
          setIsAnimating(false);
        }
      };

      requestAnimationFrame(animateScore);
    }, 200);

    return () => clearTimeout(startDelay);
  }, [widthPercent, analysisScore]);



  const bgColor =
    widthPercent > 75
      ? "bg-gradient-to-r from-[#B7ABFE] via-[#654DFF] to-[#B7ABFE]"
      : widthPercent > 40
        ? "bg-gradient-to-r from-[#FBBF24] to-[#FBBF24]"
        : "bg-gradient-to-r from-[#EF4444] to-[#EF4444]";
      
    const textColor = 
    widthPercent > 75
      ? "text-[#7964ff]"
      : widthPercent > 40
        ? "text-orange-500"
        : "text-red-500";    

    const borderColor = 
    widthPercent > 75
      ? "border-[#7964ff]"
      : widthPercent > 40
        ? "border-orange-500"
        : "border-red-500";    

  return (
    <div className="w-11/12 items-start flex flex-col px-2 bg-white p-1 rounded-xl">
      <div className="flex items-center gap-2">
      <Image
                        src="/icons/checkScoreBlack.svg"
                        alt="check score icon"
                        width={20}
                        height={20}
                      />
      <h3 className="text-lg font-semibold text-start">Total Score</h3>
      </div>
      <div className="flex w-full  items-center justify-between">
        <div className={`w-10/12 border ${borderColor} flex bg-white rounded-lg shadow-xl h-4 overflow-hidden relative`}>
          <div
            className={`flex flex-col justify-center px-5 h-4 rounded-lg text-white text-end font-medium text-xl transition-all duration-300 ease-out 
        ${widthPercent > 75 ? 'high-score-glow' : ''}
        ${bgColor} relative`}
            style={{
              width: `${percent}%`,
              transition: isAnimating ? 'none' : 'width 0.3s ease-out'
            }}
          >
            {/* Shining animation overlay */}
            <div className="absolute top-0 left-0 w-full h-full overflow-hidden">
              <div className="shine-animation"></div>
            </div>

            {/* Score text with counter animation */}

          </div>

        </div>
        <div className={`${textColor} text-2xl mx-auto font-bold`}>
          {Math.round(percent)}
        </div>
      </div>
    </div>
  );
};
